import React from "react";
import MobileHomePage from "./mobile/mobileHomePage";
import Portrait from "./web/portrait";
import * as d3 from "d3";

export default class DataHandler extends React.Component {
    state = {
        showRelevance: false,
        coOccurrenceMaxCount: 0,
        coOccurrenceThreshold: 0,
        timeList: [],
        relation: {},
        events: [],
        entities: [],
        eventRelations: [],
        coOccurrence: [],
        nodeCount: 20,
        entitiesMap: {},
        selectedEntities: [],
        unSelectedEntities: [],
        selectedEntitiesEdges: [],
        unSelectedEntitiesEdges: [],
        currentEntitiesEdges: [],
        entitiesRelation: [],
        dailyList: [],
        selectIndex: 0,
        loading: false,
    };


    componentDidMount() {
        this.setState({loading: true});
        const url = 'https://api2.newsminer.net/svc/portraitDaily/getDailyList';
        fetch(url, {
            method: 'get',
        })
            .then(response => response.json())  ///解析json数据
            .then(result => {
                result.sort();
                result.reverse();
                this.setState({dailyList: result});
                if (result.length > 0) {
                    this.loadData(result[0]);
                }
            })
            .catch(e => console.log('错误:', e));  ///请求出错
    }

    loadData = (date) => {
        this.setState({loading: true});
        //获取数据
        const url = 'https://api2.newsminer.net/svc/portraitDaily/getDailyInfo?date=' + date;

        fetch(url, {
            method: 'get',
        })
            .then(response => response.json())  ///解析json数据
            .then(result => {
                let coOccurrenceMaxCount = 0;
                if (result.coOccurrence) {
                    result.coOccurrence.forEach(item => {
                        const length = item.sentences.length;
                        if (coOccurrenceMaxCount < length) {
                            coOccurrenceMaxCount = length;
                        }
                    });
                }
                this.setState({
                    coOccurrenceMaxCount: coOccurrenceMaxCount,
                });
                //先清空
                this.init({coOccurrence: [], entities: [], events: []});
                this.init(result);
            })
            .catch(e => console.log('错误:', e));  ///请求出错
    };

    init = (result) => {
        const events = result.events;
        // const eventRelations = result.eventRelations;
        const entities = result.entities;
        const nodeCount = result.entities.length;

        const {coOccurrenceThreshold} = this.state;

        //实体列表
        let entitiesMap = {};
        let timeList = [];
        let newsIdMap = {}

        function category(index) {
            const colorList = [
                '#daccb1',
                '#c8b9a6',
                'rgb(255,207,208)',
                'rgb(200,241,255)',
                '#7b6e82',
                '#f9e9dc',
                '#b9b0a7',
                '#a29988',
                '#a77f80',
                '#ead1d4',
                '#c9c0d3',
                '#c4cada',
                '#e2e4e1',
                '#b6c5b2',
                '#959190',
                '#c2bdc3',
                '#e0d6d7',
                '#8a95a7',
                '#97a38d',
                '#d6d3cc'
            ];

            return colorList[index % colorList.length]
        }

        let eventIndexMap = {};
        events.forEach(event => {
            event.eventColor = category(event.index);
            // const time = event.time.substring(0, 10);
            // event.time = time;
            event['articleId'].forEach(id => newsIdMap[id] = event.index + 1);
            timeList.push(event.time);

            event.selected = false;
            event.entities = [];
            eventIndexMap[event.index] = event;
        });

        events.sort((a, b) => {
            if (a.time > b.time) {
                return 1;
            } else {
                return -1;
            }
        });

        // eventRelations.forEach(eventRelation => {
        //     eventRelation.target = eventIndexMap[eventRelation.targetIndex];
        //     eventRelation.source = eventIndexMap[eventRelation.sourceIndex];
        // });

        //时间
        //排序，去重，倒排
        timeList = Array.from(new Set(timeList.sort()));
        entities.forEach((entity, i) => {
            let eventColor = [];
            entity.eventIndex.forEach(index => {
                eventIndexMap[index].entities.push(entity);
                eventColor.push(category(index));
            });
            entity.eventColor = eventColor;
            entity.selected = false;
            entity.eventSelect = false;
            entity.entitySelect = false;
            entity.i = i;
            entitiesMap[entity.mention] = entity;
        });

        let set = new Set();

        result.coOccurrence.forEach(item => {
            const length = item.sentences.length;
            if (length >= 5) {
                set.add(item.fromLabel);
                set.add(item.toLabel);
            }
        });

        //result.entitiesRelation.forEach(item => {
        //    set.add(item.source);
        //    set.add(item.target);
        //});

        let entityList = [];
        entities.forEach(entity => {
            if (set.has(entity.mention)) {
                entityList.push(entity);
            }
        });

        this.setState({
            entitiesMap: entitiesMap,
            timeList: timeList,
            events: events,
            nodeCount: nodeCount,
            entities: entityList,
            coOccurrence: result.coOccurrence,
            entitiesRelation: result.entitiesRelation,
            newsIdMap: newsIdMap,
        });
        this.cal(nodeCount, coOccurrenceThreshold);
    };
    selectDate = (e) => {
        const {dailyList} = this.state;
        this.loadData(dailyList[e]);
        this.setState({selectIndex: e});
    };

    showRelevanceButton = () => {
        const {showRelevance} = this.state;
        this.setState({showRelevance: !showRelevance});
    };

    countSliderChange = (value) => {
        const {coOccurrenceThreshold} = this.state;
        this.setState({nodeCount: value});
        this.cal(value, coOccurrenceThreshold);
    };
    thresholdSliderChange = (value) => {
        const {nodeCount} = this.state;
        this.setState({coOccurrenceThreshold: value});
        this.cal(nodeCount, value);
    };

    cal = (nodeCount, coOccurrenceThreshold,) => {
        const {entities, relation, coOccurrence, entitiesMap, entitiesRelation} = this.state;

        //限定显示数量
        const currentEntities = entities.slice(0, nodeCount);

        let currentLabelList = [];
        currentEntities.forEach(entity => {
            currentLabelList.push(entity.mention);
        });
        let currentEntitiesEdges = [];
        if (relation.result0) {
            relation.result0.forEach(item => {
                const label = item.label;
                const label2 = item.label2;
                let source = {};
                let target = {};
                if (currentLabelList.indexOf(label) > -1) {
                    source = entitiesMap[label]
                }
                if (currentLabelList.indexOf(label2) > -1) {
                    target = entitiesMap[label2]
                }
                if (source.mention && target.mention) {
                    currentEntitiesEdges.push({
                        relation: item.relation,
                        source: source,
                        target: target,
                        selected: false,
                    })
                }

            })
        }
        if (coOccurrence) {
            coOccurrence.forEach(item => {
                const fromLabel = item.fromLabel;
                const toLabel = item.toLabel;

                const length = item.sentences.length;
                if (length >= 5 && length >= coOccurrenceThreshold) {
                    let source = {};
                    let target = {};
                    if (currentLabelList.indexOf(fromLabel) > -1) {
                        source = entitiesMap[fromLabel]
                    }
                    if (currentLabelList.indexOf(toLabel) > -1) {
                        target = entitiesMap[toLabel]
                    }
                    if (source.mention && target.mention) {
                        currentEntitiesEdges.push({
                            selected: false,
                            sentences: item.sentences,
                            source: source,
                            target: target,
                            relation: ''
                        })
                    }
                }
            });
        }

        if (entitiesRelation) {
            entitiesRelation.forEach(item => {
                const fromLabel = item.source;
                const toLabel = item.target;

                let source = {};
                let target = {};
                if (currentLabelList.indexOf(fromLabel) > -1) {
                    source = entitiesMap[fromLabel]
                }
                if (currentLabelList.indexOf(toLabel) > -1) {
                    target = entitiesMap[toLabel]
                }
                if (source.mention && target.mention) {
                    currentEntitiesEdges.push({
                        selected: false,
                        source: source,
                        target: target,
                        relation: item.relation
                    })
                }
            });
        }

        let selectedEntities = [];
        let unSelectedEntities = [];
        currentEntities.forEach(entity => {
            entity.selected = entity.eventSelect || entity.entitySelect;
            if (entity.selected) {
                selectedEntities.push(entity);
            } else {
                unSelectedEntities.push(entity);
            }
        });

        let selectedEntitiesEdges = [];
        let unSelectedEntitiesEdges = [];
        currentEntitiesEdges.forEach(edge => {
            if (edge.hasOwnProperty('sentences')) {
                edge.weight = edge['sentences'].length;
            } else {
                edge.weight = 20;
            }
            edge.selected = edge.source.selected && edge.target.selected;
            if (edge.selected) {
                selectedEntitiesEdges.push(edge);
            } else {
                unSelectedEntitiesEdges.push(edge);
            }
        });
        this.setState({
            selectedEntities: selectedEntities,
            unSelectedEntities: unSelectedEntities,
            selectedEntitiesEdges: selectedEntitiesEdges,
            unSelectedEntitiesEdges: unSelectedEntitiesEdges,
            currentEntitiesEdges: currentEntitiesEdges,
            loading: false
        })
    };

    eventSelected = (eventNode) => {
        const {entities, events, nodeCount, coOccurrenceThreshold} = this.state;
        if (eventNode) {
            eventNode.selected = !eventNode.selected;

            let currentSelectEvents = [];
            events.forEach(event => {
                if (event.selected) {
                    currentSelectEvents.push(event.index);
                }
            });

            //统计选中节点
            entities.forEach(entity => {
                const eventIndex = entity.eventIndex;
                let flag = false;
                for (let i = 0; i < eventIndex.length; i++) {
                    if (currentSelectEvents.indexOf(eventIndex[i]) > -1) {
                        flag = true;
                        break;
                    }
                }
                entity.eventSelect = flag;
            });
        } else {
            this.refreshNode();
        }
        this.cal(nodeCount, coOccurrenceThreshold);
    };

    entitySelected = (entityNode) => {
        const {currentEntitiesEdges, nodeCount, coOccurrenceThreshold} = this.state;
        if (entityNode) {
            entityNode.entitySelect = !entityNode.entitySelect;
            const mention = entityNode.mention;
            //统计选中节点
            currentEntitiesEdges.forEach(edge => {
                if (edge.source.mention === mention) {
                    edge.target.entitySelect = entityNode.entitySelect;
                }
                if (edge.target.mention === mention) {
                    edge.source.entitySelect = entityNode.entitySelect;
                }
            });
        } else {
            this.refreshNode();
        }
        this.cal(nodeCount, coOccurrenceThreshold);
    };

    refreshNode = () => {
        const {events, entities} = this.state;
        entities.forEach(entity => {
            entity.entitySelect = false;
            entity.eventSelect = false;
        });
        events.forEach(event => {
            event.selected = false;
        });
        d3.selectAll('g.event>rect')
            .style('stroke', selectedColor(false));
        d3.selectAll('g.event>text.eventLabel')
            .style('fill', selectedTextColor(false));

        function selectedColor(selected) {
            if (selected) {
                return '#ff7f0e';
            } else {
                return '#3eb2d7';
            }
        }

        function selectedTextColor(selected) {
            if (selected) {
                return '#ff7f0e';
            } else {
                return '#fff';
            }
        }
    };


    render() {
        const {
            coOccurrenceMaxCount, coOccurrenceThreshold, dailyList, selectIndex, loading,
            showRelevance, nodeCount, timeList, events, eventRelations, entities, newsIdMap,
            selectedEntities, unSelectedEntities, selectedEntitiesEdges, unSelectedEntitiesEdges
        } = this.state;

        let isMobile = false;

        //判断是否手机端访问
        const browser = navigator.userAgent.toLowerCase();
        const phone = /iphone|ipod|ipad|android|mobile|blackberry|webos|incognito|webmate|bada|nokia|lg|ucweb|skyfire|micromessenger/i;
        if (phone.test(browser)) {
            isMobile = true;
        }

        let page;
        if (isMobile) {
            page = <MobileHomePage
                event={events}
                dailyList={dailyList}
                selectIndex={selectIndex}
                loading={loading}
                edges={unSelectedEntitiesEdges}
                selectDate={this.selectDate}
            />;
        } else {
            page = <Portrait
                coOccurrenceMaxCount={coOccurrenceMaxCount}
                coOccurrenceThreshold={coOccurrenceThreshold}
                dailyList={dailyList}
                selectIndex={selectIndex}
                loading={loading}
                showRelevance={showRelevance}
                nodeCount={nodeCount}
                timeList={timeList}
                events={events}
                eventRelations={eventRelations}
                entities={entities}
                selectedEntities={selectedEntities}
                unSelectedEntities={unSelectedEntities}
                selectedEntitiesEdges={selectedEntitiesEdges}
                unSelectedEntitiesEdges={unSelectedEntitiesEdges}
                newsIdMap={newsIdMap}
                entitySelected={this.entitySelected}
                eventSelected={this.eventSelected}
                selectDate={this.selectDate}
                showRelevanceButton={this.showRelevanceButton}
                countSliderChange={this.countSliderChange}
                thresholdSliderChange={this.thresholdSliderChange}
            />
        }
        return page
    }
}
